import { useEffect } from "react";

export default function Cancellation() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="legal">
            <div className="container">
                <h1>Cancellation &amp; Refund Policy – CloTech AI Pvt. Ltd.</h1>
                <p><strong>Effective Date:</strong> 18.09.2025<br /><strong>Last Updated:</strong> 18.09.2025</p>
                <p>At CloTech AI Pvt. Ltd. (“CloTech AI”, “we”, “our”, “us”), we value your decision to use our CRM services. This Cancellation &amp; Refund Policy explains the terms under which cancellations are handled and refunds are (or are not) provided.</p>
                <hr />
                <h2>1. Subscription Cancellation</h2>
                <p>Customers may cancel their subscription at any time by submitting a cancellation request through the CRM platform or by contacting us at <a href="mailto:info@clotechai.com">info@clotechai.com</a> or via WhatsApp <a href="https://wa.me/919038168162" target="_blank" rel="noopener noreferrer">+91 9038168162</a>.<br />
                    We strongly encourage you to send the cancellation request from your registered email ID only.<br />
                    If a request is raised through WhatsApp from the registered number or from the CRM platform, we will still require confirmation from your registered email ID to process it.<br />
                    Cancellations take effect at the end of the current billing cycle. Until then, services remain active.</p>
                <hr />
                <h2>2. Refund Policy</h2>
                <ul>
                    <li>All sales are final. Once a subscription has been purchased and billed, no refunds or reversals will be issued, whether full or partial.</li>
                    <li>This applies to monthly and annual subscriptions, including setup fees, onboarding costs, add-on users, branches, and messaging packs (SMS/Email/WhatsApp).</li>
                    <li>No refunds are provided for unused portions of a subscription term.</li>
                </ul>
                <hr />
                <h2>3. Upgrade, Downgrade &amp; Renewal</h2>
                <ul>
                    <li>Upgrades: If you upgrade to a higher plan, charges are calculated on a pro-rata basis and billed immediately.</li>
                    <li>Downgrades: If you downgrade, changes will take effect only from the next billing cycle.</li>
                    <li>Renewals: All subscriptions auto-renew unless cancelled before the renewal date.</li>
                </ul>
                <hr />
                <h2>4. Exceptional Circumstances</h2>
                <p>Refunds will only be considered under the following rare circumstances:</p>
                <ul>
                    <li>Duplicate payment due to technical error.</li>
                    <li>Payment processed for a cancelled subscription where cancellation was confirmed in writing.</li>
                </ul>
                <hr />
                <h2>5. Contact &amp; Communication Address</h2>
                <p>
                    For any questions or concerns regarding these Terms, please <a href="/contact">contact us</a>.
                </p>
            </div>
        </div>
    );
}
